var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('b-card',{attrs:{"no-body":""}},[_c('b-col',{staticClass:"p-0"},[_c('h4',{staticClass:"p-0 my-1 mx-1"},[_vm._v(_vm._s(_vm.heading))]),_c('b-table',{attrs:{"responsive":"sm","items":_vm.items}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }